import { render, staticRenderFns } from "./AccountDisabled.vue?vue&type=template&id=8b687c4c"
import script from "./AccountDisabled.vue?vue&type=script&lang=js"
export * from "./AccountDisabled.vue?vue&type=script&lang=js"
import style0 from "./AccountDisabled.vue?vue&type=style&index=0&id=8b687c4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports